module.exports = __webpack_public_path__ + "static/media/grow-drag-delete-icon.e1662b6a.svg";